module.exports = __webpack_public_path__ + "static/logo-firebase-1da029b3c1a275f00a75e7bb3ab8d9db.png";